<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" :class="[`${prefix}-icon`, `${prefix}-icon-safeMenu`]" width="1em" height="1em" v-bind="$attrs"><path d="M40 11s-9-1-16-5c-7 4-16 5-16 5v15s2 12 16 16.027C38 38 40 26 40 26V11z" stroke="currentColor" stroke-width="4"/><path d="M16.825 22.165l6 6 10-10" stroke="currentColor" stroke-width="4"/></svg>
</template>
<script>

export default {
  name: 'IconSafeMenu',
  props: {
    prefix: {
        type: String,
        default: 'zhilv',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
